(function() {
  const section = document.querySelector('.reviews-section');
  const reviewsList = document.querySelector('.reviews-list');
  const searchInput = document.querySelector('.reviews-filters__input');
  const sortSelect = document.querySelector('.reviews-filters__select:not(.reviews-filters__select--filled)');
  const ratingSelect = document.querySelector('.reviews-filters__select--filled');
  const mediaBtn = document.querySelector('.reviews-filters__btn');

  if (!reviewsList || !section) return;

  // [R3b] Lista renderowana server-side (data-ssr) — paginujemy istniejące .review-item w DOM
  // (reuse markupu .reviews-pagination + CSS), zamiast budować listę z fetcha.
  if (reviewsList.dataset.ssr === 'true') {
    // [R3b] Lista SSR — filtrowanie (search/ocena/zdjęcia) + sort + paginacja po DOM.
    (function initSsrReviews() {
      var pp = parseInt(section.dataset.perPage) || 10;
      var pag = section.querySelector('.reviews-pagination');
      var pagesEl = section.querySelector('.reviews-pagination__pages');
      var prevBtn = section.querySelector('.reviews-pagination__prev');
      var nextBtn = section.querySelector('.reviews-pagination__next');

      function mapItem(el) {
        return {
          el: el,
          rating: parseInt(el.getAttribute('data-rating')) || 0,
          date: Date.parse(el.getAttribute('data-date') || '') || 0,
          photos: !!el.querySelector('.review-item__photos'),
          text: (el.textContent || '').toLowerCase()
        };
      }
      var all = Array.prototype.slice.call(reviewsList.querySelectorAll('.review-item')).map(mapItem);

      var mediaActive = false;
      var cur = 1;
      var view = all.slice();

      function setNoResults(show) {
        var nr = reviewsList.querySelector('.reviews-no-results');
        if (show && !nr) {
          nr = document.createElement('p');
          nr.className = 'reviews-no-results';
          nr.style.cssText = 'padding:32px 0;text-align:center;color:#888;';
          nr.textContent = 'Brak opinii spełniających kryteria.';
          reviewsList.appendChild(nr);
        } else if (!show && nr) { nr.parentNode.removeChild(nr); }
      }

      function renderPage(p) {
        var totalPages = Math.max(1, Math.ceil(view.length / pp));
        cur = Math.min(Math.max(1, p), totalPages);
        all.forEach(function(o) { o.el.style.display = 'none'; o.el.classList.remove('review-item--no-border'); });
        var pageItems = view.slice((cur - 1) * pp, cur * pp);
        pageItems.forEach(function(o) { o.el.style.display = ''; });
        if (pageItems.length) pageItems[pageItems.length - 1].el.classList.add('review-item--no-border');

        if (pagesEl) pagesEl.innerHTML = '';
        if (!pag || !pagesEl || view.length <= pp) {
          if (pag) pag.style.display = 'none';
        } else {
          pag.style.display = '';
          var pages = [];
          var maxVisible = 5;
          if (totalPages <= maxVisible + 2) {
            for (var i = 1; i <= totalPages; i++) pages.push(i);
          } else {
            pages.push(1);
            if (cur > 3) pages.push('...');
            for (var j = Math.max(2, cur - 1); j <= Math.min(totalPages - 1, cur + 1); j++) {
              if (pages.indexOf(j) === -1) pages.push(j);
            }
            if (cur < totalPages - 2) pages.push('...');
            if (pages.indexOf(totalPages) === -1) pages.push(totalPages);
          }
          pages.forEach(function(pg) {
            if (pg === '...') {
              var s = document.createElement('span');
              s.className = 'reviews-pagination__ellipsis';
              s.textContent = '...';
              pagesEl.appendChild(s);
            } else {
              (function(nn) {
                var b = document.createElement('button');
                b.type = 'button';
                b.className = 'reviews-pagination__page' + (nn === cur ? ' reviews-pagination__page--active' : '');
                b.textContent = nn;
                b.addEventListener('click', function() { renderPage(nn); reviewsList.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
                pagesEl.appendChild(b);
              })(pg);
            }
          });
          if (prevBtn) prevBtn.disabled = (cur === 1);
          if (nextBtn) nextBtn.disabled = (cur === totalPages);
        }
        setNoResults(view.length === 0);
      }

      function apply(keepPage) {
        var q = searchInput ? searchInput.value.trim().toLowerCase() : '';
        var sortV = sortSelect ? sortSelect.value : 'relevant';
        var ratingV = ratingSelect ? ratingSelect.value : 'all';
        view = all.filter(function(o) {
          if (ratingV !== 'all' && o.rating !== parseInt(ratingV)) return false;
          if (mediaActive && !o.photos) return false;
          if (q && o.text.indexOf(q) === -1) return false;
          return true;
        });
        if (sortV === 'newest') view.sort(function(a, b) { return b.date - a.date; });
        else if (sortV === 'highest') view.sort(function(a, b) { return (b.rating - a.rating) || (b.date - a.date); });
        view.forEach(function(o) { reviewsList.appendChild(o.el); });
        // [BUG#9] autoLoad woła apply(true) — zachowaj bieżącą stronę zamiast resetować na 1.
        renderPage(keepPage ? cur : 1);
      }

      
      if (searchInput) searchInput.addEventListener('input', function() { apply(); });
      if (sortSelect) sortSelect.addEventListener('change', function() { apply(); });
      if (ratingSelect) ratingSelect.addEventListener('change', function() { apply(); });
      if (mediaBtn) mediaBtn.addEventListener('click', function() {
        mediaActive = !mediaActive;
        this.style.background = mediaActive ? 'var(--pawmate-blue, #1167B1)' : 'white';
        this.style.color = mediaActive ? 'white' : '#1a1a1a';
        apply();
      });
      if (prevBtn) prevBtn.addEventListener('click', function() { renderPage(cur - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { renderPage(cur + 1); });

      apply();

      // [R3b] AUTO-DOŁADOWANIE: gdy opinii z treścią jest więcej niż w metafieldzie (cap 100),
      // dociągnij resztę z Prismy i dołóż do paginacji — automatycznie, bez przycisku/akcji usera.
      // Przy <=100 opinii nic się nie dzieje (wszystko już w SSR = instant).
      (function autoLoad() {
        var totalComments = parseInt(reviewsList.getAttribute('data-total-comments')) || all.length;
        var pid = reviewsList.getAttribute('data-product-id') || '';
        if (!pid || all.length >= totalComments) return;
        var PAW = 'M375.786,368.016c-1.022,62.699-34.434,85.385-69.898,83.283c-35.465-2.093-60.132-18.537-85.32-18.537l-1.032,0.576c-25.188,0-49.854,17.021-85.319,19.114c-35.466,2.093-68.876-19.449-69.898-82.148c2.056-57.565,45.911-61.798,83.265-129.8c32.891-59.881,71.954-55.035,71.954-55.035h1.03c0,0,39.4-4.586,71.955,55.035C329.698,308.599,373.73,310.449,375.786,368.016z M156.203,159.636c31.413-2.382,54.172-40.021,50.832-84.071c-3.34-44.049-31.514-77.828-62.927-75.446C112.695,2.501,89.936,40.141,93.276,84.19C96.616,128.239,124.789,162.018,156.203,159.636z M275.264,160.401c30.698,8.368,65.097-19.742,76.83-62.786c11.732-43.044-3.642-84.722-34.339-93.09c-30.698-8.368-65.097,19.742-76.829,62.786C229.193,110.354,244.566,152.033,275.264,160.401z M417.486,125.937c-26.732-7.288-56.688,17.19-66.905,54.674c-10.217,37.484,3.171,73.777,29.903,81.064c26.733,7.287,56.688-17.191,66.906-54.675C457.608,169.518,444.22,133.224,417.486,125.937z M102.008,180.608c-10.218-37.482-40.172-61.961-66.905-54.674s-40.122,43.581-29.904,81.064c10.218,37.482,40.173,61.961,66.906,54.674C98.837,254.386,112.225,218.092,102.008,180.608z';
        // [SEC-FIX2 2026-09-19] textContent/innerHTML NIE escapuje cudzyslowow, a wynik idzie do
        // atrybutow (src, data-review-id, data-date) - bez tego mozna bylo wyjsc z atrybutu.
        // Ta sama koncowka co w escapeHtml nizej w tym pliku.
        function esc(t) { var d = document.createElement('div'); d.textContent = (t == null ? '' : String(t)); return d.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
        function star(f) { return '<svg class="review-star ' + (f ? 'review-star--filled' : 'review-star--empty') + '" width="18" height="18" viewBox="0 0 24 24" fill="' + (f ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="' + (f ? '0' : '1.5') + '"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>'; }
        function cardHtml(r) {
          var rating = r.rating || 5, stars = '';
          for (var i = 1; i <= 5; i++) stars += star(i <= rating);
          var v = !!r.verified;
          var name = esc((r.reviewer && r.reviewer.name) || 'Klient');
          var title = r.title ? '<h3 class="review-item__title">' + esc(r.title) + '</h3>' : '';
          var body = esc(r.body || '').replace(/\n/g, '<br>');
          var dog = r.dog_info ? '<div class="review-item__dog"><svg width="16" height="16" viewBox="0 0 452.589 452.59" fill="currentColor"><path d="' + PAW + '"/></svg><span>' + esc(r.dog_info) + '</span></div>' : '';
          var photos = '';
          if (r.pictures && r.pictures.length) {
            photos = '<div class="review-item__photos">' + r.pictures.map(function(p) { return '<img class="review-item__photo" src="' + esc(p.url) + '" alt="Zdjęcie opinii" loading="lazy" width="84" height="84"/>'; }).join('') + '</div>';
          }
          var chk = v ? '<span class="review-item__avatar-check"><svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4"><polyline points="20 6 9 17 4 12"/></svg></span>' : '';
          var vsp = v ? '<span class="review-item__verified">Zweryfikowany zakup</span>' : '';
          // [SEC-FIX2 2026-09-19] data-rating szlo surowo z JSON-a API - escapujemy jak w siostrzanej funkcji.
          return '<article class="review-item" data-review-id="' + esc(r.id || '') + '" data-rating="' + esc(String(rating)) + '" data-date="' + esc(r.created_at || '') + '">' +
            '<div class="review-item__stars">' + stars + '</div>' +
            '<div class="review-item__author"><div class="review-item__avatar"><svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="8" r="4"/><path d="M12 14c-4 0-8 2-8 4v2h16v-2c0-2-4-4-8-4z"/></svg>' + chk + '</div><span class="review-item__name">' + name + '</span>' + vsp + '</div>' +
            title + '<p class="review-item__content">' + body + '</p>' + dog + photos + '</article>';
        }
        // [BUG#13] dedup po id — żywa baza może przesunąć indeksy (skip) względem snapshotu SSR.
        var seenIds = {};
        Array.prototype.forEach.call(reviewsList.querySelectorAll('.review-item[data-review-id]'), function(el) {
          seenIds[el.getAttribute('data-review-id')] = true;
        });
        var guard = 0;
        function step() {
          if (all.length >= totalComments || guard++ > 20) return;
          fetch('/apps/pawmate/reviews?product_id=' + encodeURIComponent(pid) + '&skip=' + all.length + '&per_page=100')
            .then(function(r) { return r.ok ? r.json() : null; })
            .then(function(data) {
              if (!data || !data.reviews || !data.reviews.length) return;
              var added = 0, skipped = 0;
              data.reviews.forEach(function(rv) {
                if (rv.id && seenIds[rv.id]) { skipped++; return; } // [BUG#13] pomiń już obecne
                if (rv.id) seenIds[rv.id] = true;
                var holder = document.createElement('div');
                holder.innerHTML = cardHtml(rv);
                var el = holder.firstElementChild;
                if (el) { reviewsList.appendChild(el); all.push(mapItem(el)); added++; }
              });
              if (added) { apply(true); step(); } // [BUG#9] zachowaj stronę; recursja tylko przy postępie
            })
            .catch(function() { /* sieć — zostaje to co w SSR */ });
        }
        step();
      })();
    })();
    return;
  }

  const perPage = parseInt(section.dataset.perPage) || 10;
  let allReviews = window.__pawmateAllReviews || [];
  let displayedReviews = allReviews.slice(0, perPage);
  let currentPage = 1;
  let mediaFilterActive = false;

  // Update stats if data available
  if (window.__pawmateReviewsData) {
    allReviews = window.__pawmateAllReviews || [];
    updateStats(window.__pawmateReviewsData);
    renderPagination();
  }

  // Listen for early script data ready event
  window.addEventListener('pawmateReviewsReady', function() {
    allReviews = window.__pawmateAllReviews || [];
    if (window.__pawmateReviewsData) {
      updateStats(window.__pawmateReviewsData);
    }
    renderPagination();
  });

  // Init filters
  initFilterAndSort();

  // Show fallback reviews when API fails
  function showFallbackReviews() {
    const fallback = reviewsList.querySelector('.reviews-fallback');
    if (fallback) {
      fallback.style.display = 'block';
    }
  }

  // ============================================
  // Render Reviews in Custom Format
  // ============================================
  function renderReviews(reviews) {
    reviews.forEach(review => {
      const html = createReviewHTML(review);
      reviewsList.insertAdjacentHTML('beforeend', html);
    });
  }

  function createReviewHTML(review) {
    const rating = review.rating || 5;
    const date = formatDate(review.created_at);
    const dateISO = review.created_at || ''; // [BUG#16] pełny ISO timestamp (z czasem) — sort 'newest' rozróżnia opinie z tego samego dnia

    // Parse name and dog info
    // Format: "Jan Kowalski | Pupil: Burek, Labrador, 7 lat"
    let authorName = review.reviewer?.name || review.reviewer_name || 'Klient';
    let dogInfo = review.dog_info || ''; // [BUG#8] Prisma zwraca dog_info osobno; legacy split tylko fallback

    if (!dogInfo && authorName.includes(' | Pupil: ')) {
      const parts = authorName.split(' | Pupil: ');
      authorName = parts[0].trim();
      dogInfo = parts[1].trim();
    }

    // [BUG#15] obsłuż boolean z Prismy (verified:true), nie tylko stary string 'buyer'
    const verified = review.verified === true || review.verified === 'buyer' || review.verified_buyer === true;
    const title = escapeHtml(review.title || '');
    const body = escapeHtml(review.body || review.content || '');
    const hasPhotos = review.pictures && review.pictures.length > 0;

    // Generate stars HTML
    let starsHtml = '';
    for (let i = 1; i <= 5; i++) {
      if (i <= rating) {
        starsHtml += `<svg class="review-star review-star--filled" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>`;
      } else {
        starsHtml += `<svg class="review-star review-star--empty" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>`;
      }
    }

    // Photos HTML
    let photosHtml = '';
    if (hasPhotos) {
      photosHtml = `<div class="review-item__photos">`;
      review.pictures.forEach(pic => {
        const imgUrl = pic.urls?.small || pic.urls?.compact || pic.image?.small?.url || pic.url || '';
        if (imgUrl) {
          photosHtml += `<img src="${escapeHtml(imgUrl)}" alt="Zdjęcie od klienta" loading="lazy" class="review-item__photo" width="80" height="80">`;
        }
      });
      photosHtml += `</div>`;
    }

    // Dog info HTML
    let dogInfoHtml = '';
    if (dogInfo) {
      dogInfoHtml = `
        <div class="review-item__dog">
          <svg width="16" height="16" viewBox="0 0 452.589 452.59" fill="currentColor">
            <path d="M375.786,368.016c-1.022,62.699-34.434,85.385-69.898,83.283c-35.465-2.093-60.132-18.537-85.32-18.537l-1.032,0.576c-25.188,0-49.854,17.021-85.319,19.114c-35.466,2.093-68.876-19.449-69.898-82.148c2.056-57.565,45.911-61.798,83.265-129.8c32.891-59.881,71.954-55.035,71.954-55.035h1.03c0,0,39.4-4.586,71.955,55.035C329.698,308.599,373.73,310.449,375.786,368.016z M156.203,159.636c31.413-2.382,54.172-40.021,50.832-84.071c-3.34-44.049-31.514-77.828-62.927-75.446C112.695,2.501,89.936,40.141,93.276,84.19C96.616,128.239,124.789,162.018,156.203,159.636z M275.264,160.401c30.698,8.368,65.097-19.742,76.83-62.786c11.732-43.044-3.642-84.722-34.339-93.09c-30.698-8.368-65.097,19.742-76.829,62.786C229.193,110.354,244.566,152.033,275.264,160.401z M417.486,125.937c-26.732-7.288-56.688,17.19-66.905,54.674c-10.217,37.484,3.171,73.777,29.903,81.064c26.733,7.287,56.688-17.191,66.906-54.675C457.608,169.518,444.22,133.224,417.486,125.937z M102.008,180.608c-10.218-37.482-40.172-61.961-66.905-54.674s-40.122,43.581-29.904,81.064c10.218,37.482,40.173,61.961,66.906,54.674C98.837,254.386,112.225,218.092,102.008,180.608z"/>
          </svg>
          <span>${escapeHtml(dogInfo)}</span>
        </div>
      `;
    }

    // Avatar HTML
    const avatarHtml = `
      <div class="review-item__avatar">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="8" r="4"/><path d="M12 14c-4 0-8 2-8 4v2h16v-2c0-2-4-4-8-4z"/></svg>
        <span class="review-item__avatar-check"><svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4"><polyline points="20 6 9 17 4 12"/></svg></span>
      </div>
    `;

    return `
      <!-- [SEC-FIX2 2026-09-19] rating/data z API opinii tez przez escapeHtml (ida do atrybutow) -->
      <article class="review-item" data-rating="${escapeHtml(String(rating))}" data-date="${escapeHtml(dateISO)}" data-has-photos="${hasPhotos}">
        <div class="review-item__stars">${starsHtml}</div>
        <div class="review-item__author">
          ${avatarHtml}
          <span class="review-item__name">${escapeHtml(authorName)}</span>
          ${verified ? `<span class="review-item__verified">Zweryfikowany klient</span>` : ''}
        </div>
        ${title ? `<h3 class="review-item__title">${title}</h3>` : ''}
        <p class="review-item__content">${body}</p>
        ${photosHtml}
        ${dogInfoHtml}
      </article>
    `;
  }

  // ============================================
  // Update Stats from Judge.me Data
  // ============================================
  function updateStats(data) {
    // Update average rating
    const avgRating = data.rating || data.average_rating;
    if (avgRating) {
      const ratingNumber = document.querySelector('.reviews-hero__number');
      if (ratingNumber) ratingNumber.textContent = avgRating.toFixed(1);
    }

    // Update review count
    const totalReviews = data.reviews_count || data.reviews?.length || 0;
    const countElements = document.querySelectorAll('.reviews-hero__count, .reviews-subheader__count');
    countElements.forEach(el => {
      if (el.classList.contains('reviews-hero__count')) {
        el.textContent = `Recenzje: ${totalReviews}`;
      } else {
        el.textContent = totalReviews;
      }
    });

    // Update rating breakdown bars
    if (data.rating_breakdown) {
      const breakdown = data.rating_breakdown;
      const total = Object.values(breakdown).reduce((a, b) => a + b, 0) || 1;

      for (let i = 5; i >= 1; i--) {
        const count = breakdown[i] || 0;
        const percent = Math.round((count / total) * 100);
        const bar = document.querySelector(`.reviews-breakdown__row:nth-child(${6-i}) .reviews-breakdown__fill`);
        const percentText = document.querySelector(`.reviews-breakdown__row:nth-child(${6-i}) .reviews-breakdown__percent`);
        if (bar) bar.style.width = `${percent}%`;
        if (percentText) percentText.textContent = `${percent}%`;
      }
    }

    // Update photo grid
    if (data.reviews) {
      const photosWithImages = data.reviews.filter(r => r.pictures && r.pictures.length > 0);
      const photoGrid = document.querySelector('.reviews-photo-grid');
      if (photoGrid && photosWithImages.length > 0) {
        photoGrid.innerHTML = '';
        photosWithImages.slice(0, 6).forEach(review => {
          if (review.pictures && review.pictures[0]) {
            const imgUrl = review.pictures[0].urls?.small || review.pictures[0].urls?.compact || review.pictures[0].url || '';
            if (imgUrl) {
              photoGrid.innerHTML += `
                <div class="reviews-photo-grid__item">
                  <img src="${escapeHtml(imgUrl)}" alt="Zdjęcie od klienta" loading="lazy" width="300" height="300">
                </div>
              `;
            }
          }
        });
        // Fill remaining slots with placeholders if needed
        const currentPhotos = photoGrid.querySelectorAll('.reviews-photo-grid__item').length;
        for (let i = currentPhotos; i < 6; i++) {
          photoGrid.innerHTML += `<div class="reviews-photo-grid__item reviews-photo-grid__placeholder"></div>`;
        }
      }
    }
  }

  // ============================================
  // Filter & Sort Functions
  // ============================================
  function initFilterAndSort() {
    let reviews = Array.from(reviewsList.querySelectorAll('.review-item'));

    function filterAndSort() {
      // [BUG#14] czytaj węzły NA ŻYWO — po paginacji DOM się zmienia, a guard listenera trzymał stałe
      // domknięcie z odłączonymi kartami pierwszej strony (re-doczepiało je do bieżącej).
      const reviews = Array.from(reviewsList.querySelectorAll('.review-item'));
      const searchTerm = searchInput ? searchInput.value.toLowerCase() : '';
      const sortValue = sortSelect ? sortSelect.value : 'relevant';
      const ratingValue = ratingSelect ? ratingSelect.value : 'all';

      let filtered = reviews.filter(review => {
        // Search filter
        if (searchTerm) {
          const title = review.querySelector('.review-item__title')?.textContent.toLowerCase() || '';
          const content = review.querySelector('.review-item__content')?.textContent.toLowerCase() || '';
          const author = review.querySelector('.review-item__name')?.textContent.toLowerCase() || '';
          if (!title.includes(searchTerm) && !content.includes(searchTerm) && !author.includes(searchTerm)) {
            return false;
          }
        }

        // Rating filter
        if (ratingValue !== 'all') {
          const rating = parseInt(review.dataset.rating) || 5;
          if (rating !== parseInt(ratingValue)) {
            return false;
          }
        }

        // Media filter
        if (mediaFilterActive) {
          const hasMedia = review.dataset.hasPhotos === 'true' || review.querySelector('img') !== null;
          if (!hasMedia) return false;
        }

        return true;
      });

      // Sort
      filtered.sort((a, b) => {
        if (sortValue === 'newest') {
          const dateA = a.dataset.date || '2024-01-01';
          const dateB = b.dataset.date || '2024-01-01';
          return dateB.localeCompare(dateA);
        } else if (sortValue === 'highest') {
          const ratingA = parseInt(a.dataset.rating) || 5;
          const ratingB = parseInt(b.dataset.rating) || 5;
          return ratingB - ratingA;
        }
        return 0;
      });

      // Update DOM
      reviews.forEach(review => review.style.display = 'none');
      filtered.forEach(review => {
        review.style.display = '';
        reviewsList.appendChild(review);
      });

      // Show "no results" message
      let noResults = reviewsList.querySelector('.reviews-no-results');
      if (filtered.length === 0) {
        if (!noResults) {
          noResults = document.createElement('p');
          noResults.className = 'reviews-no-results';
          noResults.textContent = 'Brak recenzji spełniających kryteria wyszukiwania.';
          noResults.style.cssText = 'text-align: center; padding: 40px 20px; color: #666;';
          reviewsList.appendChild(noResults);
        }
      } else if (noResults) {
        noResults.remove();
      }
    }

    // Event listeners — [BUG#14] bind tylko RAZ (initFilterAndSort woła się ponownie z goToPage → bez guardu
    // każda nawigacja dokładała kolejny listener = filtrowanie odpalane N razy).
    if (!initFilterAndSort._bound) {
      if (searchInput) searchInput.addEventListener('input', filterAndSort);
      if (sortSelect) sortSelect.addEventListener('change', filterAndSort);
      if (ratingSelect) ratingSelect.addEventListener('change', filterAndSort);
      if (mediaBtn) {
        mediaBtn.addEventListener('click', function() {
          mediaFilterActive = !mediaFilterActive;
          this.style.background = mediaFilterActive ? 'var(--pawmate-blue, #1167B1)' : 'white';
          this.style.color = mediaFilterActive ? 'white' : '#1a1a1a';
          filterAndSort();
        });
      }
      initFilterAndSort._bound = true;
    }
  }

  // ============================================
  // Pagination Functionality
  // ============================================
  const paginationContainer = document.querySelector('.reviews-pagination');
  const pagesContainer = document.querySelector('.reviews-pagination__pages');
  const prevBtn = document.querySelector('.reviews-pagination__prev');
  const nextBtn = document.querySelector('.reviews-pagination__next');

  function renderPagination() {
    if (!paginationContainer || !pagesContainer) return;

    const totalPages = Math.ceil(allReviews.length / perPage);

    if (totalPages <= 1) {
      paginationContainer.style.display = 'none';
      return;
    }

    paginationContainer.style.display = 'flex';
    pagesContainer.innerHTML = '';

    // Generate page buttons with ellipsis
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible + 2) {
      // Show all pages
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      // Show first, last, current and neighbors with ellipsis
      pages.push(1);

      if (currentPage > 3) pages.push('...');

      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        if (!pages.includes(i)) pages.push(i);
      }

      if (currentPage < totalPages - 2) pages.push('...');

      if (!pages.includes(totalPages)) pages.push(totalPages);
    }

    pages.forEach(page => {
      if (page === '...') {
        pagesContainer.innerHTML += '<span class="reviews-pagination__ellipsis">...</span>';
      } else {
        const isActive = page === currentPage;
        pagesContainer.innerHTML += `<button class="reviews-pagination__page ${isActive ? 'reviews-pagination__page--active' : ''}" data-page="${page}">${page}</button>`;
      }
    });

    // Update prev/next buttons
    prevBtn.disabled = currentPage === 1;
    nextBtn.disabled = currentPage === totalPages;

    // Add click handlers to page buttons
    pagesContainer.querySelectorAll('.reviews-pagination__page').forEach(btn => {
      btn.addEventListener('click', () => {
        goToPage(parseInt(btn.dataset.page));
      });
    });
  }

  function goToPage(page) {
    const totalPages = Math.ceil(allReviews.length / perPage);
    if (page < 1 || page > totalPages) return;

    currentPage = page;

    // Clear and render reviews for current page
    reviewsList.innerHTML = '';
    const start = (currentPage - 1) * perPage;
    const end = currentPage * perPage;
    renderReviews(allReviews.slice(start, end));

    // Re-init filters
    initFilterAndSort();

    // Update pagination UI
    renderPagination();

    // Scroll to reviews section
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => goToPage(currentPage - 1));
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => goToPage(currentPage + 1));
  }

  // ============================================
  // Utility Functions
  // ============================================
  function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }

  // [SEC-FIX2 2026-09-19] textContent/innerHTML NIE escapuje cudzyslowow, a wynik
  // trafia tez do atrybutow (src= przy zdjeciach opinii) - dokladamy " oraz '
  function escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

})();

/* cdn-refresh 2026-07-27 eu-launch */
